var $ = require('jquery');
var objectFitImages = require('object-fit-images');
var imagesloaded = require('imagesloaded');

// object fit images polyfill
$(function () {
    objectFitImages();
    menuPositioning();
});

// page layout

$(window).on('resize', function (e) {

    var sidebarNav = $('.sidebar-nav');
    if (sidebarNav.length) {
        $('.page-layout').css('minHeight', sidebarNav.outerHeight());
    }

    var postDetails = $('.post__details-container .info-box');
    if (postDetails.length) {
        imagesloaded(postDetails[0], function () {
            postDetails.closest('.page-section').next('.page-section--basic-content').css('minHeight', (postDetails.outerHeight() - 80));
        })
    }

    var mediaCenterInfoBox = $('.media-center__info-box');
    if (mediaCenterInfoBox.length) {
        mediaCenterInfoBox.closest('.media-center__section').css('minHeight', mediaCenterInfoBox.outerHeight());
    }

}).resize();


// layout of cards and featured content items

require('jquery-match-height');

var cardContent = $('.cards .card__content'),
    mediaColumns = $('.media-center__column--match-height'),
    featuredContent = $('.page-section--featured-content'),
    featuredContentSmallBoxes,
    featuredContentMainBox,
    featuredContentHero;

if (featuredContent.length) {
    featuredContentHero = $('.featured-content__hero-image');
    featuredContentSmallBoxes = featuredContent.find('.featured-content__item:not(.featured-content__item--1) .featured-content__item-content');
    featuredContentMainBox = $('.featured-content__item--1 .featured-content__item-content');
}

$(window).on('resize', function (e) {

    if (cardContent.length) {
        cardContent.matchHeight();
    }

    if (mediaColumns) {
        mediaColumns.matchHeight();
    }

    if (featuredContent.length) {
        featuredContentSmallBoxes.matchHeight();
        var featuredContentMainBoxPosition = featuredContentMainBox.position();
        featuredContentHero.height(featuredContentMainBoxPosition.top + (featuredContentMainBox.outerHeight() / 2));
    }

}).resize();


// fitvids

let fitvids = require('fitvids');
fitvids('.basic-content');
fitvids('.media-center__primary-video-column');
fitvids('.wysiwyg-content');

// mobile menu toggles
$('.menu-item-has-children').on('touchstart click', function (e) {
    var that = $(this);
    if (that.find('> a[href="#"]').length) {
        e.preventDefault();
        if (that.hasClass('active')) {
            that.removeClass('active');
        } else {
            $('.menu-item-has-children.active').removeClass('active');
            that.addClass('active');
        }
    }
});

$('.menu-item-has-children a').not('[href="#"]').on('touchstart click', function (e) {
    e.stopPropagation();
});

// menu positioning

function menuPositioning() {
    var mainMenuWidth = $('#menu-primary-nav').width();

    $('#menu-primary-nav .menu--columns:not(.menu--set-max-width)').each(function (i) {

        var subMenu = $(this).children('.sub-menu');
        var thisPosition = $(this).position();
        var thisWidth = $(this).innerWidth();
        var thisXPosition = thisPosition.left;
        var subMenuWidth = subMenu.innerWidth();

        var newPosition = thisXPosition - (subMenuWidth / 2) + (thisWidth / 2);

        if (newPosition < 0) {
            newPosition = 0;
        } else if ((newPosition + subMenuWidth) > mainMenuWidth) {
            subMenu.css('left', 'auto');
            subMenu.css('right', 0);
        } else {
            subMenu.css('left', newPosition);
        }
    });
}

$(window).on('resize', function (e) {

    menuPositioning();

}).resize();


// primary nav mobile toggle

$('.primary-nav__toggle a').on('click', function () {
    $(this).closest('.primary-nav').toggleClass('primary-nav--active');
});

$('.search-nav__toggle a').on('click', function () {
    $(this).parents('.primary-nav__toggle-container')
        .siblings('.search-form')
        .toggleClass('active')
        .find('input[title=Search]')
        .focus();
})

// search form toggle

$('.search-toggle').on('click', function () {
    $('.search-form').toggleClass('active');
    $('.search-form input[type="text"]').focus();
});


// disable clicks on non-links

$('a[href="#"]').on('click', function (e) {
    e.preventDefault();
});


// card listing tools

$('.card-listing__filter').on('change', function (e) {
    e.preventDefault();
    var thisValue = $(this).val(),
        taxonomy = $(this).data('taxonomy');
    if (thisValue && taxonomy) {
        window.location = '/' + taxonomy + '/' + thisValue + '/';
    }
});


// map stuff

$(function () {
    initMap();
});

var initMap = function () {
    // view toggle
    var map;
    $('.view-toggles a').on('click', function (e) {
        e.preventDefault();
        $('.view-toggles a.active').removeClass('active');
        $(this).addClass('active');

        if ($(this).attr('data-show') == "map") {
            $('.parish-finder--list').removeClass('active');
            $('.parish-finder--map').addClass('active');
            $(this).parents('.parish-finder').removeClass('list-visible');
            $(this).parents('.parish-finder').addClass('map-visible');
            center_map(map);
        } else {
            $('.parish-finder--map').removeClass('active');
            $('.parish-finder--list').addClass('active');
            $(this).parents('.parish-finder').addClass('list-visible');
            $(this).parents('.parish-finder').removeClass('map-visible');
        }
    });

    if (typeof google !== "undefined") {
        var geocoder;
        geocoder = new google.maps.Geocoder();
        $('.zip-search').on('submit', function (e) {
            e.preventDefault();
            var val = $(this).find('input').val();
            codeAddress(val);
        })
    }


    // expandables
    $('.expandable .title').click(function () {
        var wrapper = $(this).parent('.expandable');

        wrapper.toggleClass('active');

        $(this).attr('aria-expanded', function (index, attr) {
            return attr == 'false' ? 'true' : 'false';
        });
    });

    //Call this wherever needed to actually handle the display
    function codeAddress(zipCode) {
        geocoder.geocode({
            'address': zipCode
        }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                //Got result, center the map and put it out there
                map.setCenter(results[0].geometry.location);
                map.setZoom(15);
            } else {
                alert("Geocode was not successful for the following reason: " + status);
            }
        });
    }

    function new_map($el) {

        // vars
        var latlng = new google.maps.LatLng(37.09024, -95.712891);
        var args = {
            zoom: 14,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            zoomControl: true,
        };

        // create map
        map = new google.maps.Map($el[0], args);


        $(window).on('resize', function () {
            google.maps.event.trigger(map, 'resize');
        });

        // add a markers reference
        map.markers = [];

        refresh_markers($el, map);

        jQuery(document).on('facetwp-refresh', function () {
            $('.parish-finder').addClass('loading');
        });
        $('.archive-filter').show();
        jQuery(document).on('facetwp-loaded', function (obj) {
            $('.parish-finder').removeClass('loading');
            refresh_markers($el, map);

            // no results
            if ($('.parish-finder--list .marker').length == 0) {
                $('.parish-finder--map, .parish-finder--list').append('<div class="no-results-message">No results found.</div>');
            } else {
                $('.parish-finder--map .no-results-message').remove();
            }

            // if there any active facets show clear link
            var activeFacets = false,
                resetLink = $('.filter-heading-reset'),
                currentSelectedGrades = FWP.facets.grade_level;


            // for (var facet in FWP.facets) {
            //   if (FWP.facets.hasOwnProperty(facet)) {
            //     if (FWP.facets[facet].length) {
            //       activeFacets = true;
            //     }
            //   }
            // }

            // if (activeFacets && typeof currentSelectedGrades[0] !== "undefined" ) {
            //   $('.archive-filter').removeClass('hide-filters').addClass('show-filters');
            //   resetLink.show();
            // } else {
            //   $('.archive-filter').removeClass('show-filters').addClass('hide-filters');
            //   resetLink.hide();
            // }


            // if there are any groups with no facets available, hide the group
            $('.archive-filter .expandable, .archive-filter .expandable .sub-group').addClass('show')
            $('.archive-filter .expandable, .archive-filter .expandable .sub-group').each(function () {
                var parent = $(this);
                if (parent.find('.facetwp-facet').children().length == 0) {
                    parent.removeClass('show');
                }
            });
        });

        // return
        return map;

    }

    function refresh_markers($el, map) {
        // remove all markers
        for (var i = 0; i < map.markers.length; i++) {
            map.markers[i].setMap(null);
        }
        map.markers = [];

        // select markers in div that gets refreshed by facetwp
        var $markers = $('.parish-finder--list .marker, .info-box__map .marker, .location-block__map .marker');

        // add markers
        $markers.each(function () {

            add_marker($(this), map);

        });

        center_map(map);
    }

    /*
     *  add_marker
     *
     *  This function will add a marker to the selected Google Map
     *
     *  @type  function
     *  @date  8/11/2013
     *  @since 4.3.0
     *
     *  @param $marker (jQuery element)
     *  @param map (Google Map object)
     *  @return  n/a
     */
    var openInfoWindow = null;

    function add_marker($marker, map) {

        // create marker
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
        var icon = {
            url: '/wp-content/themes/adw/assets/images/marker.png',
            size: new google.maps.Size(24, 24),
            scaledSize: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(24, 24)
        }
        var marker = new google.maps.Marker({
            position: latlng,
            icon: icon,
            map: map,
            optimized: false
        });

        // add to array
        map.markers.push(marker);

        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function () {
                if (openInfoWindow) {
                    openInfoWindow.close();
                }
                openInfoWindow = infowindow;
                infowindow.open(map, marker);

            });
        }

    }

    /*
     *  center_map
     *
     *  This function will center the map, showing all markers attached to this map
     *
     *  @type  function
     *  @date  8/11/2013
     *  @since 4.3.0
     *
     *  @param map (Google Map object)
     *  @return  n/a
     */

    function center_map(map) {

        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {

            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            bounds.extend(latlng);

        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else {
            // fit to bounds
            map.fitBounds(bounds);

            // if( map.markers.length <= 3 ) {
            //   map.setZoom(12);
            //   alert('here');
            // }
        }

    }
    if ($('.parish-finder').length) {
        $('.parish-finder').each(function () {
            // create map
            var map = new_map($(this).find('.map'));

            google.maps.event.addListenerOnce(map, 'idle', function () {
                map.setZoom(map.getZoom() + 1);
            });
        });
    }

    if ($('.location-block__map, .info-box__map').length) {
        $('.location-block__map, .info-box__map').each(function () {
            // create map
            var map = new_map($(this).find('.map'));
        });
    }
}

$('.wysiwyg-content table').wrap('<div class="wysiwyg-table"></div>');


$('.search-results .view-all-link a.expand-all').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.search-result-section').find('.hidden.result .news-listing__post, .hidden.result .parish-result').unwrap('.hidden');
    $(this).remove();
})